import React from 'react';
import { Section } from './ui/Section';
import { MessageCircleX, Frown, BrainCircuit } from 'lucide-react';
export function ProblemSection() {
  return <Section background="white" data-id="element-168">
      <div className="text-center mb-12" data-id="element-169">
        <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-170">
          ¿Te suena familiar esta situación?
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-171">
          Sabemos lo frustrante que es sentir que hablas otro idioma con tu
          pareja.
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-3" data-id="element-172">
        {[{
        icon: MessageCircleX,
        text: 'Sientes que explicas todo mil veces y aun así no te entienden, como si hablaras con la pared.'
      }, {
        icon: BrainCircuit,
        text: 'Cada conversación importante termina en pelea, gritos o en un silencio incómodo que dura días.'
      }, {
        icon: Frown,
        text: "Te quedas pensando después: 'debí decir otra cosa' o te arrepientes de cómo reaccionaste."
      }].map((item, index) => <div key={index} className="flex flex-col items-center text-center p-6 rounded-2xl bg-rose-50/50 border border-rose-100" data-id="element-173">
            <div className="mb-4 p-3 bg-white rounded-full shadow-sm text-rose-500" data-id="element-174">
              <item.icon className="h-8 w-8" data-id="element-175" />
            </div>
            <p className="text-gray-700 font-medium leading-relaxed" data-id="element-176">
              "{item.text}"
            </p>
          </div>)}
      </div>

      <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-177">
        <p className="text-xl font-serif italic text-gray-500" data-id="element-178">
          No es que no sepas comunicarte. Es que nadie nos enseñó las palabras
          exactas que desactivan el conflicto y abren el corazón.
        </p>
      </div>
    </Section>;
}